// extracted by mini-css-extract-plugin
export default {"historyList":"style_historyList__MbHsf"};